<template>
    <div v-if="selectedCategories" class="categories-bar">
        <TypographyIcon width="11.25px" height="11.25px" :selected="selectedCategories.includes('typography')" />
        <AlbumArtworkIcon width="11.25px" height="11.25px" :selected="selectedCategories.includes('album_art')" />
        <ThreeDimensionalWorksIcon width="11.25px" height="11.25px" viewBox="0 0 44 57" :selected="selectedCategories.includes('three_d')" />
        <SoundDesignIcon width="11.25px" height="11.25px" :selected="selectedCategories.includes('sound_design')" />
        <OtherWorksIcon width="11.25px" height="11.25px" :selected="selectedCategories.includes('other')" />
    </div>
</template>

<style scoped>
.categories-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.categories-bar :deep(.category-icon){
    margin-right: 0;
}

.categories-bar :deep(.category-icon) svg {
    overflow: visible;
}
</style>

<script setup>
import TypographyIcon from '../atoms/typography-icon.vue';
import SoundDesignIcon from '../atoms/sound-design-icon.vue';
import AlbumArtworkIcon from '../atoms/album-artwork-icon.vue';
import ThreeDimensionalWorksIcon from '../atoms/three-dimensional-works-icon.vue';
import OtherWorksIcon from '../atoms/other-works-icon.vue';

const props = defineProps({ selectedCategories: Array, default: [] })
</script>